import { configureStore } from '@reduxjs/toolkit';
import counterReducer from '../features/counter/counterSlice.js';

import ApiUtilityReducer from "../utility/apiUtilitySlice.js";
import DetailReducer from '../page/DetailsPage/DetailSlice.js';
import FilterReducer from "../page/FilterPage/FilterSlice.js";
import NavBarReducer from "../features/NavBar/NavBarSlice.js";

import MovieTagReducer from '../features/MovieTag/MovieTagSlice.js';
import movieDataReducer from '../features/MovieTag/movieData.js';
//import MovDetailPageReducer from '../page/DetailPage/MovieDetailPage/MovDetailPageSlice.js';

export const store = configureStore({
  reducer: {
    apiUtility: ApiUtilityReducer,
    detail: DetailReducer,
    filter: FilterReducer,
    navBar: NavBarReducer,
    movieTag: MovieTagReducer,
    movieData: movieDataReducer,
    //movDetailPage: MovDetailPageReducer,
  },
});

console.log(store.getState())
